import script from "./PaymentInfoPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentInfoPop.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentInfoPop.vue?vue&type=style&index=0&id=6dc5a370&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc5a370"]])

export default __exports__